(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.treeInput
   */
  angular
    .module("akitabox.mobile.directives.treeInput", [])
    .filter("groupByNodeParent", GroupByNodeParentFilter)
    .directive("abmTreeInput", AbmTreeInputDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.treeInput
   * @name AbmTreeInputDirective
   * @restrict E
   *
   * @description
   * `<abm-tree-input>` is a container for tree type data
   *
   * @usage
   * <hljs lang="html">
   * <abm-tree-input>
   * </abm-tree-input>
   * </hljs>
   */

  /* @ngInject */
  function AbmTreeInputDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/tree-input/tree-input.html",
      controller: AbmTreeInputController,
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        editing: "=",
        label: "@",
        ngDisabled: "=?",
        ngModel: "=",
        ngChange: "&?",
        tree: "=",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      vm.populateTree();

      $scope.$watch("vm.ngModel", function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          // This only changes when someone cancels
          vm.generateTree();
          vm.populateTree();
        }
      });
    }
  }

  /* @ngInject */
  function AbmTreeInputController($log) {
    var self = this;

    if (!angular.isString(self.label)) {
      return $log.error("<abm-tree-input> label is unassigned");
    } else if (!angular.isArray(self.ngModel)) {
      return $log.error("<abm-tree-input> ng-model is unassigned");
    } else if (angular.isUndefined(self.tree)) {
      return $log.error("<abm-tree-input> tree is unassigned");
    }

    self.buildPlaceholder = buildPlaceholder;
    self.generateTree = generateTree;
    self.populateTree = populateTree;
    self.remove = remove;
    self.querySearch = querySearch;
    self.selectedItemChange = selectedItemChange;

    self.generateTree();

    function buildPlaceholder(label) {
      return "Click to set " + label.toLowerCase() + "...";
    }

    function populateTree() {
      var tree = self.nodes;
      var disabled = function (node) {
        if (node.depth === 0 || node.options.length > 1) {
          return false;
        }
        return true;
      };

      // Iterate through the tree
      // Always starting at the root node
      for (var i = 0; i < tree.length; i++) {
        var value = self.ngModel[i];
        var valueNode = null;
        var node = tree[i];
        var parent = null;
        var options = [];

        // Every option by default has ALL possible options for its dropdown already
        // Check if we need to filter down the options
        // This is only the case if the node before it already has a selected value
        if (i === 0) {
          options = self.tree;
        } else if (tree[i - 1] && tree[i - 1].value) {
          parent = tree[i - 1].value;
          options = parent.children;
        } else if (tree[i - 2] && tree[i - 2].value) {
          // We are trying to get options for a node that is 2 levels below a selected value
          // So we start at the node that we know has the value
          parent = tree[i - 2].value;

          for (var a = 0; a < parent.children.length; a++) {
            options = options.concat(parent.children[a].children);
          }
        } else if (i === 1 && !value) {
          // This is a special case for when the entire tree is completely empty
          // the 2nd drop down will need to be filtered to the first dropdown's children node
          parent = {
            children: self.tree,
          };

          for (var b = 0; b < parent.children.length; b++) {
            options = options.concat(parent.children[b].children);
          }
        }

        if (value) {
          // This node has a selected value, assign it
          for (var k = 0; k < options.length; k++) {
            if (value === options[k].name) {
              valueNode = options[k];
              break;
            }
          }
        } else if (options.length === 1) {
          valueNode = options[0];
          self.ngModel[i] = valueNode.name;
          // Logic to make sure md-autocomplete doesn't fire actual select-item-change events on our
          // automated picks
          node.autoAssigned = true;
        } else {
          node.autoAssigned = false;
        }

        node.options = options;
        node.value = valueNode;
        node.disabled = disabled(node);
      }
    }

    function generateTree() {
      var node = self.tree[0];
      var count = 0;
      var label = self.label;
      var isHidden = function (node) {
        if (node.options.length > 0) {
          return node.options[0].is_hidden;
        }

        return false;
      };

      var getOptions = function (depth) {
        if (depth <= 0) {
          return self.tree.map(function (child) {
            child.parent = self.label;
            return child;
          });
        }

        var nodes = self.nodes[depth - 1].options;
        var options = [];

        for (var i = 0; i < nodes.length; i++) {
          var option = nodes[i];

          options = options.concat(
            option.children.map(function (child) {
              child.parent = option.alias;
              return child;
            })
          );
        }

        return options;
      };

      self.nodes = []; // store default structure of dropdown
      self.options = []; // store all default options by level

      while (node) {
        var options = getOptions(count);

        self.nodes.push({
          searchText: "",
          depth: count,
          disabled: true,
          label: label,
          options: options,
          parent: null,
          value: null,
        });
        self.options[count] = options; // used later when we need to show all options for a level
        self.nodes[count].hidden = isHidden(self.nodes[count]);

        if (node.child_title.length > 0) {
          count++;
          label = node.child_title;
          node = node.children[0];
        } else {
          node = null;
        }
      }
    }

    function remove(index, node, searchText) {
      if (searchText.length !== 0) {
        return; // We only care to perform this when they have cleared the entire text
      } else if (self.ngModel.length <= index) {
        return; // don't need to remove what's not there
      }

      while (self.ngModel.length > index) {
        self.ngModel.pop();
      }

      self.populateTree();
    }

    function querySearch(index, searchText) {
      var options = [];

      if (searchText.length === 0) {
        options = self.nodes[index].options;
      } else {
        options = self.nodes[index].options.filter(function (node) {
          return node.alias.match(new RegExp(searchText, "i"));
        });
      }

      return options;
    }

    function selectedItemChange(depth, node) {
      var getMissingNode = function (depth, node, parentNode) {
        var options = [];

        if (parentNode) {
          options = self.options[depth];
        } else {
          options = self.options[0];
        }

        for (var i = 0; i < options.length; i++) {
          var option = options[i];

          if (parentNode) {
            if (option.parent === parentNode.alias) {
              for (var k = 0; k < option.children.length; k++) {
                var child = option.children[k];

                if (child.name === node.name && node.parent === child.parent) {
                  return option.name;
                }
              }
            }
          } else if (!parentNode && option.alias === node.parent) {
            return option.name;
          }
        }

        return null;
      };

      // For some reason md-autocomplete comes there here after you clear a input out
      // The node will be null, so we just ignore this call
      if (!node) {
        return;
      } else if (
        self.nodes[depth].value &&
        self.nodes[depth].value.name === node.name &&
        self.nodes[depth].value.parent === node.parent &&
        self.nodes[depth].autoAssigned
      ) {
        // very special case when this was selected by the populateTree() function and the autocomplete directive
        // thinks we selected it, and triggers and actual select event
        // We need to ignore this
        return;
      }

      // Clear all values below the selected one
      if (self.ngModel.length > 0) {
        while (self.ngModel.length - 1 > depth) {
          self.ngModel.pop();
        }
      }

      if (depth === 1 && !self.ngModel[0]) {
        // auto fill the root node
        self.ngModel[depth - 1] = getMissingNode(0, node);
        // Logic to make sure md-autocomplete doesn't fire actual select-item-change events on our automated picks
        self.nodes[depth - 1].autoAssigned = true;
      } else if (depth > 1) {
        // auto fill the missing node
        self.ngModel[depth - 1] = getMissingNode(
          depth - 1,
          node,
          self.nodes[depth - 2].value
        );
        // Logic to make sure md-autocomplete doesn't fire actual select-item-change events on our automated picks
        self.nodes[depth - 1].autoAssigned = true;
      }

      self.ngModel[depth] = node.name;
      self.populateTree();
    }
  }

  function GroupByNodeParentFilter() {
    return function (options, prop1, prop2) {
      var groups = [];
      var headers = [];

      // This groups all nodes by the passed in property
      options.sort(function (a, b) {
        if (a[prop1] > b[prop1]) {
          return 1;
        } else if (a[prop1] < b[prop1]) {
          return -1;
        } else if (a[prop2] > b[prop2]) {
          return 1;
        } else if (a[prop2] < b[prop2]) {
          return -1;
        }

        return 0;
      });

      // Tag the first occurrence of a node of a group so the template can display the group correctly
      options = options.map(function (option, index) {
        if (option.parent && groups.indexOf(option.parent) === -1) {
          groups.push(option.parent);
          headers.push({ value: option.parent, index: index });
        }

        return option;
      });

      var counter = 0;

      for (var i = 0; i < headers.length; i++) {
        var header = headers[i];

        options.splice(header.index + counter, 0, {
          alias: header.value,
          isHeader: true,
        });
        counter++;
      }

      return options;
    };
  }
})();
